module.exports = __webpack_public_path__ + "img/102.7.8bca33fb.png";